// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__zEZqu","fluid":"TextInput_fluid__3gPs5"};